import React from 'react';
import PropTypes from 'prop-types';

import { VEGGIE, PLANT_BASED } from '../modules/constants';
const VEGGIE_CLASS = 'veggie';
const PLANT_BASED_CLASS = 'plantBased';

/**
 * Originally displayed either the veggie or vegan friendly label on a menu item.
 * Since vegan was removed, this no longer displays anything about vegan recipes.
 * The logic remains, so if we ever revert that choice it'll be simple to add this back in
 *
 * @function
 * @param       {string} diets string, either `VEGGIE` or `VEGAN`
 * @constructor
 */
function VeggieOrVegan({ diets }) {
    const plantBased =
        diets.indexOf('VEGA') !== -1
            ? true // change to remove vegan friendly from menu
            : diets.indexOf('VEGE') !== -1
            ? false
            : null;

    if (plantBased === null) {
        return null;
    }

    return (
        <i className={plantBased ? PLANT_BASED_CLASS : VEGGIE_CLASS}>
            {plantBased ? PLANT_BASED : VEGGIE}
        </i>
    );
}

VeggieOrVegan.propTypes = {
    diets: PropTypes.string
};

export { VeggieOrVegan };
